<script setup lang="ts">
import { computed } from 'vue';
import { CdrText } from '@rei/cedar';
import RagSearchBar from '../../../components/ragSearchBar/RagSearchBar.vue';
import GladlySearch from '../../../components/gladlySearchBar/GladlySearch.vue';
import { useIcons } from '../../../common/composables/useIcons';

const props = defineProps<{
  isHomePage: boolean;
  isContactStandalone: boolean;
}>();

const showRagBar = computed(() => props.isHomePage && !props.isContactStandalone);
</script>

<template>
  <div v-if="!showRagBar">
    <GladlySearch />
  </div>
  <div v-else>
    <div>
      <div
        class="rag-bar"
      >
        <div>
          <div class="rag-bar__heading-wrap">
            <component
              :is="useIcons('IconAiSearch')"
              class="rag-bar__heading-icon"
            />
            <CdrText
              tag="h1"
              class="rag-bar__heading"
              tabindex="0"
              data-ui="coop-help-center"
            >
              Get Answers Instantly
            </CdrText>
          </div>
          <CdrText
            tag="p"
            class="rag-bar__subheading"
            tabindex="0"
            data-ui="coop-help-center"
          >
            Ask AI about orders, returns, memberships and more. Or browse help topics below.
          </CdrText>
          <RagSearchBar />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import 'src/main/style/rag/rag-bar.scss';
</style>
